import React from "react";

import { Icon } from "@proda-ai/ui-kit";

import Box from "@/ui/atoms/Box";

import type { ICellRendererParams } from "@/ui/molecules/Grid";

import type { TRowReviewWithOperatingStatements } from "../../typesGrids";

const cellStylesWithEllipsis = {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    height: "100%",
    padding: "8px",
};

type GridAnnualizationRendererFirstColumnProps =
    ICellRendererParams<TRowReviewWithOperatingStatements>;

const GridAnnualizationRendererFirstColumn: React.FC<
    GridAnnualizationRendererFirstColumnProps
> = params => {
    const { data } = params;

    if (!data) return null;

    const isPinnedTotalRow =
        data?.rowId === "row-altered" || data?.rowId === "row-original";

    if (
        data.type === "TYPE" ||
        data.type === "SECTION" ||
        data.type === "TOTAL"
    ) {
        return (
            <Box
                sx={{
                    backgroundColor: isPinnedTotalRow
                        ? "var(--proda-light-blue)"
                        : "var(--proda-white-l95)",
                    fontWeight: "bold",
                    textAlign: "right",
                    ...cellStylesWithEllipsis,
                }}
            >
                {data.account}
            </Box>
        );
    }

    if (data.type === "HEADER") {
        return (
            <Box
                sx={{
                    backgroundColor: "var(--proda-white-130)",
                    fontWeight: "bold",
                    ...cellStylesWithEllipsis,
                }}
            >
                {data.account}
            </Box>
        );
    }

    if (data.type === "SUBSECTION") {
        const chevronIcon =
            data.isExpanded === true ? "chevron-down" : "chevron-right";
        return (
            <Box
                sx={{
                    ...cellStylesWithEllipsis,
                    gap: "8px",
                    cursor: "pointer",
                    fontWeight: "400",
                }}
            >
                <Icon icon={chevronIcon} />
                <Box sx={{ ...cellStylesWithEllipsis, padding: 0 }}>
                    {data.account}
                </Box>
            </Box>
        );
    }

    if (data.parentRowId == null) {
        return (
            <Box
                sx={{
                    ...cellStylesWithEllipsis,
                    gap: "8px",
                    fontWeight: "400",
                    color: "var(--proda-black-10)",
                }}
            >
                <Box sx={{ visibility: "hidden", display: "flex" }}>
                    <Icon icon="chevron-right" />
                </Box>
                <Box sx={{ ...cellStylesWithEllipsis, padding: 0 }}>
                    {data.account}
                </Box>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                fontWeight: "400",
                color: "var(--proda-black-10)",
                ...cellStylesWithEllipsis,
                paddingLeft: "36px",
            }}
        >
            {data.account}
        </Box>
    );
};

export default GridAnnualizationRendererFirstColumn;
